// format number with padding two zeros
const nw02p = num => num.toString().padStart(2, '0')

const isToday = date => {
  const now = new Date()
  return now.getFullYear() === date.getFullYear() &&
    now.getMonth() === date.getMonth() &&
    now.getDate() === date.getDate()
}

export { nw02p, isToday }
